module.exports = __webpack_public_path__ + "img/home.4f4ce38c.svg";